import HiddenIdTypeaheadController from './hidden_id_typeahead_controller'

// The contact-form company typeahead (segment criteria #231, contacts filter #233):
// as you type a name, fetch matching workspace companies and offer them in the shared
// hidden-id combobox; picking one writes the company UUID into the hidden field and
// its name into the visible input.
//
// This is deliberately NOT contact-autocomplete: that controller fills an editable
// email input with the picked value, whereas here the visible input is a label and the
// submitted value is a separate hidden id. All the combobox mechanics live in the
// shared base (HiddenIdTypeaheadController); this subclass only names the option row.
export default class extends HiddenIdTypeaheadController {
  optionMarkup(company, index) {
    const id = `company-suggestion-${index}`
    const name = this.escape(company.name)
    return `
      <li id="${id}" role="option" aria-selected="false" class="list-group-item list-group-item-action" data-index="${index}"
          data-action="mousedown->company-autocomplete#choose">
        ${name}
      </li>`
  }
}
